import React, { FC, KeyboardEvent, ChangeEvent } from "react";
import * as BoxModule from "@mui/material/Box/index.js";
import * as FormHelperTextModule from "@mui/material/FormHelperText/index.js";
import * as TextFieldModule from "@mui/material/TextField/index.js";
import { resolveDefault } from "../../utils/moduleInterop";

const Box = resolveDefault<any>(BoxModule);
const FormHelperText = resolveDefault<any>(FormHelperTextModule);
const TextField = resolveDefault<any>(TextFieldModule);

interface TextfieldProps {
	type?: string;
	id?: string;
	label?: string;
	name: string;
	placeholder?: string;
	value: any;
	error?: any;
	disabled?: boolean;
	onChange: (event: ChangeEvent<HTMLInputElement>) => void;
	handleBlur?: () => void;
	helperText?: string;
}

const Textfield: FC<TextfieldProps> = ({
	type,
	id,
	label,
	name,
	placeholder,
	value,
	error,
	disabled,
	onChange,
	handleBlur,
	helperText,
}) => {
	return (
		<Box>
			<form noValidate autoComplete="off">
				<TextField
					id={id}
					label={label}
					type={type}
					variant="outlined"
					placeholder={placeholder}
					name={name}
					value={value}
					onBlur={handleBlur}
					onChange={onChange}
					fullWidth
					disabled={disabled}
					error={!!error}
					size="small"
					onKeyPress={(e: KeyboardEvent) => {
						if (e.key === "Enter") e.preventDefault();
					}}
				/>
				{helperText && <FormHelperText>{helperText}</FormHelperText>}
				{error && <FormHelperText error>{error}</FormHelperText>}
			</form>
		</Box>
	);
};

Textfield.defaultProps = {
  label: "Text Input",
  name: "",
  placeholder: "",
  value: "",
  error: "",
  helperText: "Helper text",
};

export default Textfield;
